var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-0.11 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(16.226 16.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26909",
    "data-name": "Trac\\xE9 26909",
    d: "M4,9.689A1.689,1.689,0,0,1,5.689,8H19.2a1.689,1.689,0,0,1,1.689,1.689V19.825A1.689,1.689,0,0,1,19.2,21.514H5.689A1.689,1.689,0,0,1,4,19.825Z",
    transform: "translate(-2.311 -4.621)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26910",
    "data-name": "Trac\\xE9 26910",
    d: "M4,16l6.335,5.068a3.379,3.379,0,0,0,4.223,0L20.893,16",
    transform: "translate(-2.311 -9.243)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26911",
    "data-name": "Trac\\xE9 26911",
    d: "M0,0H20.272V20.272H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(0.11 -0.39)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    rx: 26.5,
    ry: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    rx: 25.5,
    ry: 25,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e467c3352132d523fda266c258792024.svg";
export { ForwardRef as ReactComponent };